import React from "react";
import { useSiteData } from "../../context/SiteDataContext";

const AboutSection = () => {
  const { content, siteConfig } = useSiteData();
  const about = content?.about || {};
  const aboutPhoto = "/about-marsu.png";

  return (
    <section id="about" className="relative py-20 overflow-hidden">
      <div className="absolute inset-0 bg-[#060d06]" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12">
          <div className="flex-1 flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-green-500/10 rounded-full blur-[150px]" />
              <img src={aboutPhoto} alt="Marsupilami" className="relative w-[450px] h-auto sm:w-[640px] object-contain animate-hero-float drop-shadow-[0_0_50px_rgba(46,204,113,0.2)]" />
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-6">
              <span className="text-yellow-400">{about.title || "MARSUPILAMI'S HOME"}</span>
            </h2>
            <p className="text-gray-400 text-lg leading-relaxed max-w-xl">
              {about.description || "MARSUPILAMI COIN rises from the ashes!"}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
